import { TableViewMode } from 'entities/Table';
import { FormActionsStore } from 'stores/common/form';
import { TableFactoryStore } from 'stores/common/table';
import { ILocalStore } from 'stores/interfaces';

import { ColumnsSettingsDrawerStore } from '../FormReviewFlatTableStore/ColumnsSettingsDrawerStore';

type FormReviewStoreParams = {
  id: number | null;
};

class FormReviewPivotTableStore implements ILocalStore {
  constructor({ id }: FormReviewStoreParams) {
    this.id = id;
    this.formActionsStore = new FormActionsStore({
      store: this.tableStore,
    });
  }

  readonly tableStore: TableFactoryStore = new TableFactoryStore();

  readonly formActionsStore: FormActionsStore;

  readonly columnsSettingsDrawer = new ColumnsSettingsDrawerStore({
    headerStore: this.tableStore.tableHeaderStore,
  });

  readonly id: number | null;

  async init(): Promise<void> {
    if (!this.id) {
      return;
    }

    await this.tableStore.init({
      form_id: this.id,
      view: TableViewMode.pivot,
    });
    await this.formActionsStore.fetchActions();
  }

  destroy() {
    this.tableStore.destroy();
    this.columnsSettingsDrawer.destroy();
  }
}

export default FormReviewPivotTableStore;
